import { BigNumber } from 'ethers';
import { formatUnits, parseUnits } from 'ethers/lib/utils';
import { UserPositionRaw } from '../../hooks/web3/trade/useUserPositions';
import calculatePnl from '../calculations/calculatePnl';
import { config } from '../../config/config';

const generateClosePositionLog = (
    userPosition: UserPositionRaw,
    price: string,
    margin: string,
    userFee: BigNumber
) => {
    let removedPercentage: string = '1',
        fees: string | undefined;

    const pnlValues = calculatePnl(userPosition, price);

    const estimatedPnl = pnlValues?.pnl;

    if (estimatedPnl) {
        const payout = parseUnits(estimatedPnl, config.priceFeedDecimal)
            .add(parseUnits(margin, config.priceFeedDecimal))
            .mul(parseUnits(removedPercentage, config.priceFeedDecimal))
            .div(parseUnits('1', config.priceFeedDecimal));

        fees = formatUnits(payout.mul(userFee).div(100_00), config.priceFeedDecimal);
    }

    return { estimatedPnl, fees };
};

export default generateClosePositionLog;
